<template>
    <div class="form">
        <h4 class="step-title">
            Do you need an SR-22?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <yes-no-button-list v-bind:onclick="complete"></yes-no-button-list>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "./shared/YesNoButtonList.vue"

    export default {
        name: "NeedsSr22",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(needsSr22) {
              this.lead.needsSr22 = needsSr22;
              this.$emit("complete", this.$options.name, needsSr22);
          }
        }
    }
</script>
